import React from 'react'
import styled from 'styled-components'
import ReCAPTCHA from 'react-google-recaptcha'
import { useStoreState, useStoreActions } from 'easy-peasy'
import ErrorMessage from './ErrorMessage'
import media from '../../utils/media'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px auto 15px;
  #captcha-captcha,
  .g-recaptcha {
    width: 100%;
    ${media.mobileM`
    transform:scale(0.77);
    transform-origin:0 0;
  `}
    ${media.mobileS`
    transform:scale(0.66);
    transform-origin:0 0;
  `}
  }
`

export default function Captcha({ name }) {
  const [{ key }, error] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
  ])
  const [
    setInputValue,
    deleteInputValue,
  ] = useStoreActions(actions => [
    actions.form.setInputValue,
    actions.form.deleteInputValue,
  ])

  return (
    <Container className="col-xs-12 form-group">
      <ReCAPTCHA
        id={`captcha-${name}`}
        name={name}
        ref={React.createRef()}
        sitekey={key}
        onChange={value => {
          if (value) {
            setInputValue({ name, value })
          } else {
            deleteInputValue(name)
          }
        }}
      />
      <ErrorMessage error={error} id={`error-${name}`} />
    </Container>
  )
}
